import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import HomePage from "../pages/main/HomePage";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import AccountPage from "../pages/main/AccountPage";
import ClaimPage from "../pages/main/ClaimPage";
import { WalletProvider } from "../context/WalletContext";

export default function Router() {
    return (
        <BrowserRouter>
            <WalletProvider>
                <Header />
                <Routes>
                    <Route path="/" element={<HomePage />}></Route>
                    <Route path="/account" element={<AccountPage />}></Route>
                    <Route path="/claim" element={<ClaimPage />}></Route>
                </Routes>
                <Footer />
            </WalletProvider>
        </BrowserRouter>
    )
}